import type { ProjectConfigInput } from '#core/schema/ProjectConfigSchema.ts';

export const config = {
  id: 'cognite-dashboard-core',
  name: 'Cognite Dashboard',
} as const satisfies ProjectConfigInput;
